function removeNoJs(){

  jQuery('body').removeClass('no-js');
}

function randomBg(){

  var randomNum = Math.floor(Math.random() * 10);

  jQuery('body.home').addClass('home-bg-' + randomNum);
}

function logoLinked(){

  var logoArea = jQuery('.title-area');

  logoArea.wrapInner('<a href="/" class="title-area__cta" title="Home" />');
}

function showSearch(){

  jQuery('#menu-item-144').on('click', function(event){

    jQuery('#overlay').fadeIn(400);
    jQuery('#website-search').addClass('pinned');
    event.preventDefault();

  });
}

function hideSearch(){

  jQuery('#website-search__close').on('click', function(event){

    jQuery('#overlay').fadeOut(100);
    jQuery('#website-search').removeClass('pinned');
    event.preventDefault();

  });
}

function resetSearch(){
    
    var searchIconVis = jQuery('#menu-item-144').is(':visible');

    if ( !searchIconVis ) {

      jQuery('#overlay').fadeOut(100);
      jQuery('#website-search').removeClass('pinned');

    }
}

function scrollFunction() {

  var navToggleVis = jQuery('#genesis-mobile-nav-primary').is(':visible');

  if ( ( document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) && !( navToggleVis ) && (whatInput.ask() === 'mouse') ) {
   
    jQuery('#site-header').addClass('pinned');
    jQuery('#header-area-2').hide();

  } else {
    
    jQuery('#site-header').removeClass('pinned');
    jQuery('#header-area-2').show();

  }
}

function backToTop(){

  if (  document.body.scrollTop > 80 || document.documentElement.scrollTop > 80 ) {
   
    jQuery('#back-to-top').fadeIn(300);

  } else {
    
    jQuery('#back-to-top').fadeOut(300);
  }

}

function scrollToTop(){

  jQuery('#back-to-top').on('click', function() {

    jQuery('html, body').animate({
      scrollTop: 0
    }, 700);

    return false;

  });
}

function fadeOutBgOverlay(){

  jQuery('#bg-overlay').fadeOut(1500);
}

function moveShare() {

  var share = jQuery('#addthis_container');

  share.appendTo('.post-column-1');
}

jQuery(document).ready(function(){

  logoLinked();
  removeNoJs();
  randomBg();
  scrollToTop();
  showSearch();
  hideSearch();

});

jQuery(window).on('resize', function(){

  resetSearch();

});


jQuery(window).on('scroll', function(){

  backToTop();
  scrollFunction();

});

jQuery(window).on('load', function(){

  fadeOutBgOverlay();
  moveShare();
});